import { storeCreator } from '@/utils/store/store.utils';

interface State {
  state: {
    modalVisible: boolean;
    successMessage: string | null;
  };
  handleChangeVisibility: (value: boolean) => void;
  handleSetSuccessMessage: (successMessage: string | null) => void;
  handleReset: () => void;
}

export const useStore = storeCreator<State>((set) => ({
  state: {
    modalVisible: false,
    successMessage: null,
  },
  handleChangeVisibility: (value) => set((state) => ({
    ...state,
    state: {
      ...state.state,
      modalVisible: value,
    },
  })),
  handleSetSuccessMessage: (successMessage) => set((state) => ({
    ...state,
    state: {
      ...state.state,
      successMessage,
    },
  })),
  handleReset: () => set((state) => ({
    ...state,
    state: {
      ...state.state,
      modalVisible: false,
      successMessage: null,
    },
  })),
}));

export default () => {
  const store = useStore();
  return {
    ...store,
  };
};
